/**
 * Which build is running (Trello abquRFhf), for bug reports and test notes.
 *
 * Never a number someone types: CI derives the version from the release tags
 * and the commit from git, and stamps them into the bundle as VUE_APP_VERSION
 * and VUE_APP_COMMIT (.github/workflows/port-tests.yml), and into the API image
 * as APP_VERSION / APP_COMMIT, which the API reports on GET /me only.
 *
 * Shown in the private layout's footer, so only after sign-in. The bundle's own
 * stamp is readable by anyone who downloads the JavaScript - accepted, because
 * the bundle's content hashes already fingerprint the build - but no page an
 * unauthenticated visitor sees prints it, and the API's half is not public at
 * all.
 */

/** This bundle's stamp; nulls for a local build CI never touched. */
export function frontendBuild() {
  return {
    version: process.env.VUE_APP_VERSION || null,
    commit: process.env.VUE_APP_COMMIT || null,
  };
}

/** "1.4.2 (abc1234)", the version or short commit alone, or "unstamped". */
export function describeBuild(build) {
  const version = build && build.version ? String(build.version) : "";
  const commit = build && build.commit ? String(build.commit).slice(0, 7) : "";

  if (version && commit) return `${version} (${commit})`;

  return version || commit || "unstamped";
}

/**
 * Whether the bundle and the API are different builds, for the footer's flag
 * (the card's step 4: a support person reading a bug report needs to know the
 * FE and API were not deployed together). Compared by commit when both carry
 * one, by version otherwise; unknown - an unstamped half, or before GET /me
 * answers - is not a difference.
 */
export function buildsDiffer(frontend, api) {
  const commitOf = (build) => (build && build.commit ? String(build.commit) : "");
  const versionOf = (build) => (build && build.version ? String(build.version) : "");

  if (commitOf(frontend) && commitOf(api)) return commitOf(frontend) !== commitOf(api);
  if (versionOf(frontend) && versionOf(api)) return versionOf(frontend) !== versionOf(api);

  return false;
}

/** The deployment this bundle was built for (VUE_APP_ENVIRONMENT_NAME), or "". */
export function environmentName() {
  return process.env.VUE_APP_ENVIRONMENT_NAME || "";
}
